import { HttpClient } from '@/shared/lib/http-client';

export const fetchNotificationMessageById = async (messageId) => {
  const response = await HttpClient.get(`/notifications/${messageId}`);

  return response.data;
};
